export const VisitPriority = {
  NORMAL: 'normal',
  HIGH: 'high'
};
